import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b027ce20&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b027ce20&prod&scoped=true&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=b027ce20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b027ce20",
  null
  
)

export default component.exports